// extracted by mini-css-extract-plugin
export var assignment = "AssignmentViewer-module--assignment--2y5iY";
export var assignmentDisabled = "AssignmentViewer-module--assignmentDisabled--6Fsuy";
export var retakeSubmission = "AssignmentViewer-module--retakeSubmission--1lz07";
export var embed = "AssignmentViewer-module--embed--2IPtZ";
export var loadingWrapper = "AssignmentViewer-module--loadingWrapper--3mtYj";
export var loading = "AssignmentViewer-module--loading--pLIiR";
export var spin = "AssignmentViewer-module--spin--37SO4";